module.exports = __webpack_public_path__ + "static/img/sys-2.4391f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys-2.png
// module id = 3Mh2
// module chunks = 1